import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  loanAmmount: "100000",
  timePeriod: "5",
  intrestRate: "6.5",
  edErrors: null,
  totalAmount: 0,

}

const educationSlice = createSlice({
  name: 'educationCalculator',
  initialState,
  reducers: {

    setLoanAmmount: (state, action) => {
      state.loanAmmount = action.payload;
    },
    setTimePeriod: (state, action) => {
      state.timePeriod = action.payload;
    },
    setIntrestRate: (state, action) => {
      state.intrestRate = action.payload;
    },
    setEdErrors: (state, action) => {
      state.edErrors = action.payload;
    },
    setEmi: (state, action) => {
      state.emi = action.payload;
    },
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    resetEducationData: (state) => {
      return initialState;
    },
  }
});

export const { setActiveCalculater } = educationSlice.actions;
export const {
  setLoanAmmount, setTimePeriod, setIntrestRate, setEdErrors, setEmi, resetEducationData, setTotalAmount
} = educationSlice.actions;
export default educationSlice.reducer;
